/**
 * 載具類型
 * null = 無載具（統編）
 * 1 = 綠界電子發票載具
 * 2 = 自然人憑證（暫不使用）
 * 3 = 手機條碼載具
 * 4 = 悠遊卡（暫不使用）
 * 5 = 一卡通（暫不使用）
 * Ref: ZOEKIT-17955
 */
export enum InvoiceCarrierType {
  EasyCard = 1,
  NaturalPersonCertificate = 2,
  MobileBarcode = 3,
  EasyPassCard = 4,
  iPASS = 5,
}

/**
 * 訂單詳細頁發票顯示資訊
 * 後端 API: GET /v2/funnow/order/:orderid
 * Ref: ZOEKIT-17955
 */
export interface InvoiceDisplayInfo {
  /** 發票號碼，如 AB-12345678。有發票才有值 */
  invoice_number?: string | null
  /** 載具類型整數，null 表示無載具（可能有統編） */
  carrier_type?: number | null
  /** 載具號碼（手機條碼格式 /XXXXXXX，8碼） */
  carrier_num?: string
  /** 統一編號（8位數字） */
  tax_id?: string | null
}

/**
 * 發票資訊物件（API invoice_info 欄位）
 * Ref: ZOEKIT-17955
 */
export interface InvoiceInfo {
  carrier_type?: number | null
  carrier_num?: string
  tax_id?: string | null
  invoice_number?: string | null
}

/**
 * 結帳頁 UI 內部的載具選項（三個 radio）
 * Ref: ZOEKIT-17684
 */
export type InvoiceCarrierOption = 'member' | 'mobileBarcode' | 'companyTax'

/**
 * 送出訂單時的載具 payload（對應 ZOEKIT-17957 API spec）
 * Ref: ZOEKIT-17684
 */
export interface InvoiceCarrierPayload {
  /** uint8: 1=綠界電子發票, 3=手機條碼; 公司統編不帶此欄位 */
  carrier_type?: number
  /** 手機條碼格式 /XXXXXXX（8碼），電子發票載具不帶 */
  carrier_num?: string
}

/**
 * 會員已儲存的載具（對應 ZOEKIT-17959 GET /v2/funnow/member response 扁平欄位）
 * Ref: ZOEKIT-17684, ZOEKIT-17959
 */
export interface MemberCarrier {
  /** 上次建單所選的載具類型，null = 從未建過單；實際只會出現 1 | 3 | null */
  last_carrier_type: InvoiceCarrierType | null
  /** 手機條碼號碼，空字串 = 從未輸入過 */
  mobile_barcode: string
}
